import React from "react";
import type { OtcFollowupAnswer } from "../types";
import { YesNoRadio } from "./YesNoRadio";

// Round 19 — a required Yes/No question with a conditional, required detail box
// shown only on "Yes". This factors out the pattern the Health History grid
// builds inline (a YesNoRadio followed by a conditional explanation textarea)
// into one shared component, so the OTC follow-up questions render identically.
// Switching to "No" clears the detail so stale text can't leak into the
// PDF/export (mirrors the grid's on-No clear).
export function YesNoWithDetail({
  name,
  label,
  value,
  onChange,
  detailLabel = "Please provide details",
  detailRows = 2,
  errorAnswer,
  errorDetail,
}: {
  name: string;
  label: React.ReactNode;
  value: OtcFollowupAnswer;
  onChange: (next: OtcFollowupAnswer) => void;
  detailLabel?: React.ReactNode;
  detailRows?: number;
  errorAnswer?: string;
  errorDetail?: string;
}) {
  const answer = value?.answer ?? null;
  const detail = value?.detail ?? "";
  return (
    <div>
      <YesNoRadio
        name={name}
        label={label}
        value={answer}
        onChange={(v) => onChange({ answer: v, detail: v === "No" ? "" : detail })}
        error={errorAnswer}
      />
      {answer === "Yes" && (
        <div className="mt-2 rounded-md border border-slate-200 bg-slate-50 p-3">
          <label className="field-label">{detailLabel}</label>
          <textarea
            className="field-input"
            rows={detailRows}
            value={detail}
            onChange={(e) => onChange({ answer, detail: e.target.value })}
          />
          {errorDetail && <p className="field-error">{errorDetail}</p>}
        </div>
      )}
    </div>
  );
}
